import { NgClass } from '@angular/common';
import { Component, computed, effect, inject, input, output, signal, viewChild } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { SelectErrorState } from '@ui';

import { Space, SpaceType } from '../../../models/spaces';
import { LocationService } from '../../../services';

@Component({
  imports: [
    MatSelectModule,
    MatIconModule,
    NgClass,
    MatExpansionModule,
  ],
  selector: 'avs-space-selector',
  templateUrl: './space-selector.component.html',
})
export class SpaceSelectorComponent extends SelectErrorState {
  changed = output<string | null>();
  panelClosed = output<void>();
  location = input.required<string>();
  parent = input<string>();
  type = input.required<SpaceType>();
  value = input<string>();
  cssClass = input<string>();
  disabled = input(false);
  displayType = input<'select' | 'panel' | 'filter'>('select');
  required = input<boolean>(false);
  hasError = input<boolean>(false);

  protected select = viewChild(MatSelect);
  protected eSpaceType = SpaceType;
  protected locationService = inject(LocationService);
  protected spaces = signal<Space[]>([]);
  protected selectedSpace = computed(() => this.spaces().find(space => space.id === this.value()) || null);
  protected isDisabled = computed(() =>
    this.disabled() || !this.spaces().length || !this.location() || (this.type() === SpaceType.room && !this.parent()),
  );

  constructor() {
    super();

    effect(() => {
      if (!this.location() || (this.type() === SpaceType.room && !this.parent())) {
        return;
      }

      const options = {
        includeNestedDevices: 'true',
        type: this.type(),
        ...this.parent() && { parentId: this.parent() },
      };

      this.locationService.getSpacesList(this.location(), options)
        .subscribe(locations => this.spaces.set(locations));
    });
  }

  protected valueChanged($event: string) {
    this.changed.emit($event);
  }

  protected onPanelChange(isOpen: boolean) {
    if (!isOpen) {
      this.panelClosed.emit();
    }
  }
}
